import styled from 'styled-components';

export const SociologicalResearchStyles = styled.div`
  font-family: 'Montserrat';
  position: relative;
  overflow: hidden;

  .container {
    max-width: 1190px;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 0 auto;
    position: relative;
  }
`;
